import type { DataMapName } from '@wix/thunderbolt-becky-types'
import type { ByRefsisDataNode } from './utils/dataNodeUtils'
import { pointers } from '@wix/thunderbolt-becky-types'
import { Connections } from './Connections'
import { Behaviors } from './Behaviors'
import { Slots } from './Slot'
import { DocumentData } from './DocumentData'

const {
	DATA_MAPS: { CONNECTIONS, BEHAVIORS, SLOTS, DATA },
} = pointers.data

export const byRefsisDataNodes: { [dataMapName in DataMapName]?: ByRefsisDataNode<any, any, any> } = {
	[CONNECTIONS]: Connections,
	[BEHAVIORS]: Behaviors,
	[SLOTS]: Slots,
	[DATA]: DocumentData,
}
